module.exports = __webpack_public_path__ + "static/media/adventureParkIcon.3b9729e5.png";